const myPointsList = []

export default {
  myPointsList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/store/state.js